import {
  Banner,
  BannerVariant,
  BannerStatus,
  BannerLeftAccessoryType,
} from "@gocardless/flux-react";
import { Trans } from "@lingui/macro";

export const RequirePasswordResetMessage = () => (
  <Banner
    variant={BannerVariant.Light}
    leftAccessory={{
      type: BannerLeftAccessoryType.Status,
      status: BannerStatus.Warning,
    }}
    title={
      <Trans id="sign-in-page.force-password-reset.title">
        Please go to your email and reset your password.
      </Trans>
    }
  >
    <Trans id="sign-in-page.force-password-reset.message">
      To help keep your account secure, we require you to update your password.
      We have sent you an email containing further instructions.
    </Trans>
  </Banner>
);
